import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import LessonCard from "./LessonCard";

const LessonsCarousel = ({ lessons, onClick }) => {
  // Sort lessons by lesson.id and then by lesson_number
  const sortedLessons = [...lessons].sort((a, b) => {
    if (a.lesson_id !== b.lesson_id) {
      return a.lesson_id - b.lesson_id; // First sort by lesson.id
    }
    return a.lesson_number - b.lesson_number; // Then sort by lesson_number
  });

  return (
    <Swiper
      spaceBetween={10}
      slidesPerView={2}
      loop={true}
      modules={[Autoplay]}
      initialSlide={0}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      className="lessonsCarousel"
      breakpoints={{
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 8 },
      }}
    >
      {sortedLessons.map((lesson, index) => (
        <SwiperSlide key={index}>
          <LessonCard lesson={lesson} onClick={onClick} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default LessonsCarousel;
